import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getPatientCAAMetricsYearQueryKey(
  patientId: string,
  { personaName, year }: { personaName?: string; year: number }
) {
  return ['patientCAAMetricsYear', patientId, { personaName, year }]
}

export function usePatientCAAMetricsYearQuery({
  patientId,
  personaName,
  year,
  enabled
}: {
  patientId: string
  personaName?: string
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getPatientCAAMetricsYearQueryKey(patientId, {
      personaName,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getPatientCAAMetricsYear({
        patientId,
        personaName,
        year
      }),
    enabled
  })
}
